import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CropSettings } from "../../../domain/media";

@Component({
  selector: "evrideo-crop-settings-editor",
  templateUrl: "./crop-settings-editor.component.html",
  styleUrls: ["./crop-settings-editor.component.scss"],
})
export class CropSettingsEditorComponent implements OnInit {
  @Input()
  title = "Crop Settings";
  @Input()
  cropSettings: CropSettings;

  @Output()
  valueUpdated = new EventEmitter<void>();
  constructor() {}

  ngOnInit(): void {}
  calculateTopMax() {
    if (this.cropSettings) {
      const result = 99 - this.cropSettings.bottom;
      return result;
    }
    return 50;
  }
  calculateLeftMax() {
    if (this.cropSettings) {
      const result = 99 - this.cropSettings.right;
      return result;
    }
    return 50;
  }
  calculateRightMax() {
    if (this.cropSettings) {
      const result = 99 - this.cropSettings.left;
      return result;
    }
    return 50;
  }
  calculateBottomMax() {
    if (this.cropSettings) {
      const result = 99 - this.cropSettings.top;
      return result;
    }
    return 50;
  }

  resetCropSettings() {
    this.cropSettings.reset();
  }
}
